import lozad from 'lozad';
import { Fancybox} from "@fancyapps/ui";

Fancybox.bind("[data-fancybox]", {
    Thumbs: {
        autoStart: false,
    },
});

//Blocks
import '@components/header/scripts';
import '@components/radio-tumbler/scripts';
import '@components/input/scripts';
import '@components/input-number/scripts';
import '@components/select-links/scripts';
import '@components/accordion/scripts';
import '@components/backdrop/scripts';
import "@components/slider/scripts";
import "@components/filter/scripts";
import "@components/map/scripts";
import "@components/modal/scripts";
import "@components/preloader/scripts";
import "@components/tooltip/scripts";

//Cards
import "@components/card/card-review/scripts";
import "@components/card/card-question/scripts";

//Sections
import '@components/section/section-intro/scripts';
import '@components/section/section-path/scripts';
import '@components/section/section-events/scripts';
import '@components/section/section-teachers/scripts';
import '@components/section/about-courses/scripts';

import Cookies from '@components/cookies/scripts.js';



const init = () => {
  const observer = lozad();
  observer.observe();
  new Cookies();
};

document.addEventListener("DOMContentLoaded", function(event) {
	function isWebp() {
	  // Проверка поддержки webp
	  function testWebP(callback) {
		let webP = new Image();
		webP.onload = webP.onerror = function () {
		  callback(webP.height == 2);
		};
		webP.src = "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
	  }
	  // Добавление класса _webp или _no-webp для HTML
	  testWebP(function (support) {
		let className = support === true ? 'webp' : 'no-webp';
		document.documentElement.classList.add(className);
	  });
	}
	isWebp();
})

const smoothLinks = document.querySelectorAll('a[href^="#"]');
for (let smoothLink of smoothLinks) {
	smoothLink.addEventListener('click', function (e) {
		e.preventDefault();
		const id = smoothLink.getAttribute('href');

		if(id != '#'){
			document.querySelector(id).scrollIntoView({
				behavior: 'smooth',
				block: 'center'
			});
		}
	});
};

export default init;
